import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ResponsiveNavbar from './components/ResponsiveNavbar';
import Footer from './components/Footer';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';

// Page imports
import Home from './pages/Home';
import About from './pages/About';
import Announcements from './pages/Announcements';
import Archives from './pages/Archives';
import Authors from './pages/Authors';
import BecomeReviewer from './pages/BecomeReviewer';
import Contact from './pages/Contact';
import Copyright from './pages/Copyright';
import CurrentPublications from './pages/CurrentPublications';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminDashboardEnhanced from './pages/AdminDashboardEnhanced';
import ComprehensiveAdminDashboard from './pages/ComprehensiveAdminDashboard';
import AdminPortal from './pages/AdminPortal';
import EditorDashboard from './pages/EditorDashboard';
import EditorInChief from './pages/EditorInChief';
import EditorialBoard from './pages/EditorialBoard';
import EditorialTeam from './pages/EditorialTeam';
import Ethics from './pages/Ethics';
import GuideForAuthors from './pages/GuideForAuthors';
import Guidelines from './pages/Guidelines';
import InformationForReaders from './pages/InformationForReaders';
import Issues from './pages/Issues';
import Login from './pages/Login';
import ManagingEditor from './pages/ManagingEditor';
import ManuscriptHandlingFee from './pages/ManuscriptHandlingFee';
// import ManuscriptTemplate from './pages/ManuscriptTemplate';
import OpenAccessPolicy from './pages/OpenAccessPolicy';
import PaperDetails from './pages/PaperDetails';
import PaperView from './pages/PaperView';
import PaymentMethods from './pages/PaymentMethods';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PublicationCharges from './pages/PublicationCharges';
import PublicationFee from './pages/PublicationFee';
import Register from './pages/Register';
import ReviewProcess from './pages/ReviewProcess';
import Search from './pages/Search';
import SpecialIssues from './pages/SpecialIssues';
import SubmitPaper from './pages/SubmitPaper';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="app-container">
          <ResponsiveNavbar />
          <main className="main-content">
            <PageTransition>
              <Routes>
                {/* Main Pages */}
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/search" element={<Search />} />

                {/* Publications */}
                <Route path="/current-publications" element={<CurrentPublications />} />
                <Route path="/archives" element={<Archives />} />
                <Route path="/issues" element={<Issues />} />
                <Route path="/issues/:id" element={<Issues />} />
                <Route path="/special-issues" element={<SpecialIssues />} />
                <Route path="/announcements" element={<Announcements />} />

                {/* Author Services */}
                <Route path="/authors" element={<Authors />} />
                <Route path="/guide-for-authors" element={<GuideForAuthors />} />
                <Route path="/submit-paper" element={<SubmitPaper />} />
                {/* <Route path="/manuscript-template" element={<ManuscriptTemplate />} /> */}
                <Route path="/review-process" element={<ReviewProcess />} />
                <Route path="/ethics" element={<Ethics />} />
                <Route path="/guidelines" element={<Guidelines />} />

                {/* Editorial */}
                <Route path="/editorial-board" element={<EditorialBoard />} />
                <Route path="/editorial-team" element={<EditorialTeam />} />
                <Route path="/editor-in-chief" element={<EditorInChief />} />
                <Route path="/managing-editor" element={<ManagingEditor />} />
                <Route path="/become-reviewer" element={<BecomeReviewer />} />

                {/* Fees & Policies */}
                <Route path="/publication-charges" element={<PublicationCharges />} />
                <Route path="/publication-fee" element={<PublicationFee />} />
                <Route path="/manuscript-handling-fee" element={<ManuscriptHandlingFee />} />
                <Route path="/payment-methods" element={<PaymentMethods />} />
                <Route path="/open-access-policy" element={<OpenAccessPolicy />} />
                <Route path="/copyright" element={<Copyright />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                {/* Reader Services */}
                <Route path="/information-for-readers" element={<InformationForReaders />} />

                {/* User Account */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/paper/:id" element={<PaperDetails />} />
                <Route path="/admin" element={<AdminPortal />} />
                <Route path="/admin/cms" element={<ComprehensiveAdminDashboard />} />
                <Route path="/admin-dashboard" element={<ComprehensiveAdminDashboard />} />
                <Route path="/editor-dashboard" element={<EditorDashboard />} />
              </Routes>
            </PageTransition>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;